import { appClient } from './appClient';
import * as localEntities from './entities/index.js';
import { supabase } from '@/integrations/supabase/client';

// Prefer SDK entities when available; fall back to local mocks
export const Lead = appClient.entities?.Lead ?? localEntities.Lead;
export const Service = appClient.entities?.Service ?? localEntities.Service;
export const Deal = appClient.entities?.Deal ?? localEntities.Deal;
export const Case = appClient.entities?.Case ?? localEntities.Case;
export const Customer = appClient.entities?.Customer ?? localEntities.Customer;
export const Contact = appClient.entities?.Contact ?? localEntities.Contact;

// User: merge auth (me, logout) with real Supabase persistence
export const User = {
  ...(localEntities.User || {}),
  ...(appClient.auth || {}),
  
  // Real implementation using Supabase
  async me() {
    const { data: { user: authUser } } = await supabase.auth.getUser();
    if (!authUser) throw new Error('Not authenticated');
    
    const { data: appUser, error } = await supabase
      .from('app_users')
      .select(`
        *,
        system_role:system_roles(
          id,
          name,
          code
        )
      `)
      .eq('auth_user_id', authUser.id)
      .single();
      
    if (error) throw error;
    
    return {
      ...appUser,
      email: authUser.email,
      role: appUser.system_role?.name || 'User'
    };
  },
  
  async updateMyUserData(data) {
    const { data: { user: authUser } } = await supabase.auth.getUser();
    if (!authUser) throw new Error('Not authenticated');
    
    const { data: updatedUser, error } = await supabase
      .from('app_users')
      .update(data)
      .eq('auth_user_id', authUser.id)
      .select()
      .single();
      
    if (error) throw error;
    return updatedUser;
  }
};